// organizationSearchSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    "user_id": '',
    "orgname": '',
    "value_added":[],
    "direct_billing":[],
    "main_number":'',
    "main_number_code":'',
    "created_day":'',
    "created_month":'',
    "created_year":'',
    "user_id_inverse": '',
    "orgname_inverse": '',
    "value_added_inverse":'',
    "direct_billing_inverse":'',
    "created_date_inverse_inverse":'',
    "main_number_inverse":'',
    "match": false,
    "orgsearchApplied": false,
};

const organizationSearchSlice = createSlice({
    name: 'organizationSearch',
    initialState,
    reducers: {
        setOrganizationSearch(state, action) {
            return { ...state, ...action.payload };
        },
        resetOrganizationSearch(state) {
            return { ...initialState, orgsearchApplied: false }; // Reset state and flag
        },
        setOrgSearchApplied(state) {
            state.orgsearchApplied = true; // Directly set searchApplied to true
        },
    },
});

export const { setOrganizationSearch, resetOrganizationSearch,setOrgSearchApplied } = organizationSearchSlice.actions;

export default organizationSearchSlice.reducer;